'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { applyLandingLanguage, useLandingLanguage } from '@/hooks/useLandingLanguage';
import { getIndustryCopy, type IndustryKey } from '@/lib/cadrino-landing/industry-copy';
import { useWebsitePagesCopy } from '@/lib/cadrino-landing/useWebsitePagesCopy';
import { CadrinoMarketingHeader } from './CadrinoMarketingHeader';
import { CadrinoFooter } from './CadrinoFooter';
import { ContactSection } from './ContactSection';
import { MarketingHero } from './MarketingHero';
import { CadrinoShell, Container, MotionBlock, Section } from './shared';
export function CadrinoIndustryPage(t0) {
  const $ = _c(9);
  const {
    industryKey
  } = t0;
  const {
    language
  } = useLandingLanguage();
  const copy = getIndustryCopy(industryKey, language);
  const pages = useWebsitePagesCopy();
  let t1;
  let t2;
  if ($[0] !== language) {
    t1 = () => {
      applyLandingLanguage(language);
    };
    t2 = [language];
    $[0] = language;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CadrinoMarketingHeader />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== copy.finalCta.body || $[5] !== copy.finalCta.button || $[6] !== copy.finalCta.title) {
    t4 = <ContactSection title={copy.finalCta.title} subtitle={copy.finalCta.body} primaryLabel={copy.finalCta.button} primaryHref="#contact-form" />;
    $[4] = copy.finalCta.body;
    $[5] = copy.finalCta.button;
    $[6] = copy.finalCta.title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CadrinoFooter />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return <CadrinoShell>{t3}<main><MarketingHero variant="inner" eyebrow={copy.hero.eyebrow} title={copy.hero.title} subtitle={copy.hero.subtitle} highlights={copy.hero.bullets} primaryCtaLabel={copy.finalCta.button} primaryCtaHref="#contact" secondaryCtaLabel={pages.nav.product} secondaryCtaHref="/product" />{copy.sections.map(_temp)}{t4}</main>{t5}</CadrinoShell>;
}
function _temp(section, index) {
  return <Section key={section.title} className={index % 2 === 1 ? "border-t border-white/[0.08] bg-cadrino-surface/30" : "border-t border-white/[0.08]"}><Container><MotionBlock><h2 className="text-xl font-semibold text-slate-100">{section.title}</h2><p className="mt-4 max-w-3xl text-sm leading-relaxed text-cadrino-muted">{section.body}</p></MotionBlock></Container></Section>;
}